(function () {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const state = window.__elyseeMobileViewport || {
    active: false,
    width: 0,
    height: 0,
    stageHeight: 0,
    layoutHeight: 0,
    visualHeight: 0,
    stickyTop: 0,
    updatedAt: 0
  };

  window.__elyseeMobileViewport = state;

  const getViewportHeight = () => Math.max(
    320,
    Math.round(window.innerHeight || document.documentElement.clientHeight || 1)
  );

  let lastCssHeight = 0;

  const updateCssVars = () => {
    if (state.stageHeight === lastCssHeight) return;

    lastCssHeight = state.stageHeight;
    document.documentElement.style.setProperty('--elysee-mobile-viewport-height', `${state.stageHeight}px`);
    document.documentElement.style.setProperty('--elysee-stable-vh', `${state.stageHeight / 100}px`);
  };

  const disableMobileSmoothScroll = () => {
    document.documentElement.classList.toggle('elysee-native-mobile-scroll', mobileQuery.matches);

    if (!mobileQuery.matches) return;

    const lenis = window.__elyseeLenis;
    if (!lenis || lenis.__elyseeMobileDisabled) return;

    try {
      if (typeof lenis.stop === 'function') lenis.stop();
      if (typeof lenis.destroy === 'function') lenis.destroy();
    } catch (error) {
      // A broken smooth-scroll instance should never block native mobile scroll.
    }

    lenis.__elyseeMobileDisabled = true;
    if (window.__elyseeLenis === lenis) window.__elyseeLenis = null;
  };

  const measure = (force = false) => {
    const width = Math.round(window.innerWidth || document.documentElement.clientWidth || 1);
    const isMobile = mobileQuery.matches;
    const widthChanged = Math.abs(width - state.width) > 2;

    state.active = isMobile;

    if (!isMobile) {
      state.width = width;
      state.height = getViewportHeight();
      state.stageHeight = state.height;
      state.layoutHeight = state.height;
      state.visualHeight = Math.round(window.visualViewport?.height || state.height);
      state.stickyTop = 0;
      state.updatedAt = Date.now();
      updateCssVars();
      return;
    }

    if (!force && state.stageHeight && !widthChanged) {
      updateCssVars();
      return;
    }

    const height = getViewportHeight();
    state.width = width;
    state.height = height;
    state.stageHeight = height;
    state.layoutHeight = height;
    state.visualHeight = Math.round(window.visualViewport?.height || height);
    state.stickyTop = 0;
    state.updatedAt = Date.now();
    updateCssVars();
    disableMobileSmoothScroll();
  };

  measure(true);

  window.addEventListener('orientationchange', () => window.setTimeout(() => measure(true), 240), { passive: true });
  window.addEventListener('resize', () => measure(false), { passive: true });
  const handleMobileQueryChange = () => {
    measure(true);
    disableMobileSmoothScroll();
  };

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', handleMobileQueryChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleMobileQueryChange);
  }
  document.addEventListener('DOMContentLoaded', () => measure(false), { once: true });
  window.setTimeout(disableMobileSmoothScroll, 600);
  window.setTimeout(disableMobileSmoothScroll, 1800);
})();
